import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import { CREATIVE_REPORT_ID } from './creativeReportId';

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.SPENT.field,
        FIELDS.BID_MODIFICATION.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.VCTR.field,
        FIELDS.CLICKS.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.CVR.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.CPA.field,
        FIELDS.VCPM.field,
        FIELDS.CONVERSIONS_VALUE.field,
        FIELDS.ROAS.field,
    ].map(field => generateColumnId(CREATIVE_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [
        FIELDS.URL.field,
        FIELDS.AD_ID.field,
        FIELDS.CREATIVE_ID.field,
        FIELDS.CUSTOM_CREATIVE_NAME.field,
        FIELDS.CHANNEL_TYPE.field,
        FIELDS.CREATIVE_ORIENTATION.field,
        FIELDS.FORMAT.field,
        FIELDS.SIZE.field,
        FIELDS.CUSTOM_ID.field,
        FIELDS.STATUS.field,
        FIELDS.REACH.field,
        FIELDS.ACCOUNT_ID.field,
        FIELDS.ACCOUNT_DESCRIPTION.field,
        FIELDS.CAMPAIGN_ID.field,
        FIELDS.CAMPAIGN_NAME.field,
        FIELDS.CAMPAIGNS_GROUP_ID.field,
        FIELDS.CAMPAIGNS_GROUP_NAME.field,
        FIELDS.START_DATE.field,
        FIELDS.END_DATE.field,
        FIELDS.CREATE_TIME.field,
        FIELDS.DESCRIPTION.field,
        FIELDS.CTA.field,
    ].map(field => generateColumnId(CREATIVE_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.STATUS.field,
    FIELDS.REACH.field,
    FIELDS.CUSTOM_CREATIVE_NAME.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.THUMBNAIL_URL_COMFORTABLE.field,
    FIELDS.TITLE.field,
    FIELDS.CONTENT.field,
    FIELDS.CHANNEL_TYPE.field,
    FIELDS.CREATIVE_ORIENTATION.field,
    FIELDS.URL.field,
    FIELDS.AD_ID.field,
    FIELDS.CREATIVE_ID.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.CAMPAIGN_NAME.field,
    FIELDS.CAMPAIGNS_GROUP_NAME.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.VCTR.field,
    FIELDS.CLICKS.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.VCPM.field,
    FIELDS.START_DATE.field,
    FIELDS.END_DATE.field,
    FIELDS.CREATE_TIME.field,
    FIELDS.DESCRIPTION.field,
    FIELDS.CTA.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CREATIVE_REPORT_ID, field));

const performanceColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.CUSTOM_CREATIVE_NAME.field,
    FIELDS.CHANNEL_TYPE.field,
    FIELDS.AD_ID.field,
    FIELDS.CREATIVE_ID.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.THUMBNAIL_URL_COMFORTABLE.field,
    FIELDS.TITLE.field,
    FIELDS.CONTENT.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.VCTR.field,
    FIELDS.CLICKS.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.VCPM.field,
    FIELDS.ACTIONS_COLUMN.field,
    FIELDS.CONVERSIONS_VALUE.field,
    FIELDS.ROAS.field,
].map(field => generateColumnId(CREATIVE_REPORT_ID, field));

const setupColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.CUSTOM_CREATIVE_NAME.field,
    FIELDS.CUSTOM_ID.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.THUMBNAIL_URL_COMFORTABLE.field,
    FIELDS.TITLE.field,
    FIELDS.CONTENT.field,
    FIELDS.CHANNEL_TYPE.field,
    FIELDS.REACH.field,
    FIELDS.CREATIVE_ORIENTATION.field,
    FIELDS.FORMAT.field,
    FIELDS.SIZE.field,
    FIELDS.URL.field,
    FIELDS.AD_ID.field,
    FIELDS.CREATIVE_ID.field,
    FIELDS.STATUS.field,
    FIELDS.ACCOUNT_ID.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.CAMPAIGN_ID.field,
    FIELDS.CAMPAIGN_NAME.field,
    FIELDS.CAMPAIGNS_GROUP_ID.field,
    FIELDS.CAMPAIGNS_GROUP_NAME.field,
    FIELDS.START_DATE.field,
    FIELDS.END_DATE.field,
    FIELDS.CREATE_TIME.field,
    FIELDS.DESCRIPTION.field,
    FIELDS.CTA.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CREATIVE_REPORT_ID, field));

const rsocFPColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.AD_ID.field,
    FIELDS.CREATIVE_ID.field,
    FIELDS.STATUS.field,
    FIELDS.URL.field,
    FIELDS.THUMBNAIL_URL.field,
    FIELDS.THUMBNAIL_URL_COMFORTABLE.field,
    FIELDS.CONTENT.field,
    FIELDS.TITLE.field,
    FIELDS.DESCRIPTION.field,
    FIELDS.CTA.field,
    FIELDS.CREATE_TIME.field,
    FIELDS.START_DATE.field,
    FIELDS.END_DATE.field,
].map(field => generateColumnId(CREATIVE_REPORT_ID, field));

export { customColumns, defaultColumns, performanceColumns, setupColumns, rsocFPColumns };
